import { render, staticRenderFns } from "./UnitDetails.vue?vue&type=template&id=589b4e0c"
import script from "./UnitDetails.vue?vue&type=script&lang=js"
export * from "./UnitDetails.vue?vue&type=script&lang=js"
import style0 from "./UnitDetails.vue?vue&type=style&index=0&id=589b4e0c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports